var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PhotoInput',{attrs:{"photo":_vm.logo},on:{"change":_vm.savePhoto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }